<template>
  <div class="inspection-route-map-container">
    <div id="inspectionRouteMap" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script>
import { listInspectionRoutePoints } from '@/api/inspection/inspectionPointApi'
import { getCommunityId } from '@/api/community/communityApi'
import { listSystemInfo } from '@/api/system/systemInfoManageApi'

export default {
  name: 'InspectionRouteMap',
  data() {
    return {
      map: null,
      communityId: '',
      routePoints: [],
      amapKey: '',
      markers: [],
      polyline: null
    }
  },
  async mounted() {
    this.communityId = getCommunityId()
    await this.loadAmapKey()
    await this.loadAmapScript()
  },
  methods: {
    async loadAmapKey() {
      try {
        const { data } = await listSystemInfo({ page: 1, row: 1 })
        if (data && data.length > 0 && data[0].qqMapKey) {
          this.amapKey = data[0].qqMapKey
        } else {
          this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
        }
      } catch (error) {
        console.error('获取地图Key失败:', error)
        this.amapKey = '2d4592252d5a8e57f8eb1b47aaef0d24'
      }
    },

    loadAmapScript() {
      if (window.AMap) {
        return Promise.resolve()
      }

      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = `https://webapi.amap.com/maps?v=2.0&key=${this.amapKey}`
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },

    loadData(route) {
      this.initMap()
      this.loadRoute(route)
    },

    initMap() {
      // 清除之前的标记和折线
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => marker.setMap(null))
        this.markers = []
      }
      if (this.polyline) {
        this.polyline.setMap(null)
        this.polyline = null
      }
      if (this.map) {
        this.map.destroy()
        this.map = null
      }

      // 默认中心点（北京）
      const center = [116.397128, 39.916527]

      // 创建地图实例
      this.map = new window.AMap.Map('inspectionRouteMap', {
        center: center,
        zoom: 13,
        viewMode: '2D'
      })
    },

    async loadRoute(route) {
      if (!route || !route.inspectionRouteId) return

      try {
        const params = {
          communityId: this.communityId,
          inspectionRouteId: route.inspectionRouteId,
          page: 1,
          row: 1000
        }

        const response = await listInspectionRoutePoints(params)
        this.routePoints = response.inspectionPoints
        this.addPointsToMap(this.routePoints)
      } catch (error) {
        console.error('获取路线点失败:', error)
        this.$message.error(this.$t('inspectionRouteMap.fetchError'))
      }
    },

    addPointsToMap(points) {
      if (!this.map || !points || points.length === 0) return

      // 清除之前的标记和折线
      if (this.markers && this.markers.length > 0) {
        this.markers.forEach(marker => marker.setMap(null))
        this.markers = []
      }
      if (this.polyline) {
        this.polyline.setMap(null)
        this.polyline = null
      }

      const path = []

      points.forEach(point => {
        if (!point.lat || !point.lng) return

        const position = [point.lng, point.lat]
        path.push(position)

        // 创建标记，带文本标签
        const marker = new window.AMap.Marker({
          position: position,
          map: this.map,
          icon: '/img/maper.png',
          offset: new window.AMap.Pixel(-13, -30),
          label: {
            content: point.inspectionName,
            direction: 'bottom',
            offset: new window.AMap.Pixel(0, 5)
          }
        })

        this.markers.push(marker)
      })

      // 创建路径折线
      if (path.length > 1) {
        this.polyline = new window.AMap.Polyline({
          path: path,
          strokeColor: '#3777FF',
          strokeWeight: 6,
          strokeOpacity: 0.8,
          lineJoin: 'round',
          lineCap: 'round'
        })
        this.polyline.setMap(this.map)
      }

      // 自动调整地图视野以包含所有点
      if (path.length > 0) {
        if (path.length === 1) {
          this.map.setCenter(path[0])
          this.map.setZoom(16)
        } else {
          this.map.setFitView(this.markers)
        }
      }
    }
  },
  beforeDestroy() {
    // 组件销毁时清除地图实例
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  }
}
</script>

<style scoped>
.inspection-route-map-container {
  width: 100%;
  height: 100%;
}
</style>